// WebSocket Events
export var ChatSocketEvent;
(function (ChatSocketEvent) {
    ChatSocketEvent["ADMIN_MESSAGE"] = "admin-message";
    ChatSocketEvent["NEW_MESSAGE"] = "new-message";
    ChatSocketEvent["MESSAGE_STATUS_UPDATED"] = "message-status-updated";
    ChatSocketEvent["CHAT_STATUS_UPDATED"] = "chat-status-updated";
    ChatSocketEvent["CHAT_READ"] = "chat-read";
    ChatSocketEvent["NEW_CHAT_CREATED"] = "new-chat-created";
    // 🎫 NEW TICKET EVENTS
    ChatSocketEvent["TICKET_ASSIGNED"] = "ticket-assigned";
    ChatSocketEvent["TICKET_PRIORITY_CHANGED"] = "ticket-priority-changed";
    ChatSocketEvent["TICKET_CLOSED"] = "ticket-closed";
    ChatSocketEvent["TICKET_REOPENED"] = "ticket-reopened";
    ChatSocketEvent["OPERATOR_TYPING"] = "operator-typing";
})(ChatSocketEvent || (ChatSocketEvent = {}));
